require('core-js/fn/symbol');
require('core-js/fn/promise');
require('core-js/fn/array');
require('core-js/fn/object');

import UserManager from './userManager';
import { getToken, revokeToken } from './userManager/token';
import { registerEvent } from './helpers/customEvent';
import { TOKEN_LOADED } from './helpers/constants';

registerEvent(TOKEN_LOADED);
UserManager();

window.xpSession = {
  get token() {
    return getToken() ? getToken().access_token : null;
  },
  get user() {
    return getToken();
  },
  get complete() {
    return !!getToken();
  },
  get logout() {
    return revokeToken();
  }
};
